import {BaseMenuItem} from '@models/sidebar/response/base-menu-item';
import {MenuItemIcon} from '@models/sidebar/menu-item-icon';
import {MenuItemType} from '@models/sidebar/menu-item-type';

export class MenuItem extends BaseMenuItem {
  icon: MenuItemIcon = MenuItemIcon.NONE;
  favoriteToggle: boolean = false;
  isFavorite: boolean = false;
  parent: any;
  menuItemParent: MenuItem | undefined = undefined;

  /**
   * @deprecated - use firebaseUserId
   */
  userId: number = -1;
  firebaseUserId: string = '';
  isShared: boolean | undefined = false;
  nodeId?: string = undefined;

  get parentIsMachineGroup(): boolean {
    return !!this.machineGroupId;
  }

  get isMachine(): boolean {
    return this.type === MenuItemType.MACHINE;
  }

  get isEditable(): boolean {
    return this.isMachineGroup || this.isMachine;
  }
}
